"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeptStaffTree = getDeptStaffTree;
exports.queryStaffUserPage = queryStaffUserPage;
exports.syncDepartment = syncDepartment;
exports.syncDepartmentUser = syncDepartmentUser;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getDeptStaffTree() {
  return (0, _requestAuth.default)({
    url: '/staffDept/tree',
    method: 'get'
  });
}
function syncDepartment() {
  return (0, _requestAuth.default)({
    url: '/staffDept/syncStaffDept',
    method: 'get'
  });
}
function syncDepartmentUser() {
  return (0, _requestAuth.default)({
    url: '/staffUser/syncDeptUser',
    method: 'get'
  });
}
function queryStaffUserPage(query) {
  return (0, _requestAuth.default)({
    url: '/staffUser/page',
    method: 'get',
    params: query
  });
}